import { getRoot } from "mobx-state-tree";

export const couponsFactoryViews = self => ({

});
